// extracted by mini-css-extract-plugin
export default {"imageBack":"styles_imageBack__1t9ql","buttonSend":"styles_buttonSend__KeLTE"};